import {
  Assignment as AssignmentIcon,
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  TrendingUp as TrendingUpIcon,
} from "@mui/icons-material";
import {
  Alert,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { ItemStatusStatistics } from "../../../types/admin";

interface ItemStatusStatisticsCardsProps {
  data?: ItemStatusStatistics;
  isLoading: boolean;
  error: any;
}

const ItemStatusStatisticsCards: React.FC<ItemStatusStatisticsCardsProps> = ({
  data,
  isLoading,
  error,
}) => {
  const { t } = useTranslation();

  if (error) {
    return <Alert severity="error">{t("admin.itemStatus.failedToLoadStatistics")}</Alert>;
  }

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  const cards = [
    {
      title: t("admin.itemStatus.totalStatuses"),
      value: data.totalStatuses,
      icon: <AssignmentIcon />,
      color: "primary.main",
    },
    {
      title: t("admin.itemStatus.activeStatuses"),
      value: data.activeStatuses,
      icon: <CheckCircleIcon />,
      color: "success.main",
    },
    {
      title: t("admin.itemStatus.inactiveStatuses"),
      value: data.inactiveStatuses,
      icon: <ErrorIcon />,
      color: "error.main",
    },
    {
      title: t("admin.itemStatus.statusesWithItems"),
      value: data.statusesWithItems,
      icon: <TrendingUpIcon />,
      color: "info.main",
    },
  ];

  return (
    <Grid container spacing={3}>
      {cards.map((card, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Card>
            <CardContent>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <Box
                  sx={{
                    p: 1,
                    borderRadius: 1,
                    backgroundColor: card.color,
                    color: "white",
                    mr: 2,
                  }}
                >
                  {card.icon}
                </Box>
                <Typography variant="h6" component="div">
                  {card.title}
                </Typography>
              </Box>
              <Typography
                variant="h4"
                component="div"
                sx={{ fontWeight: "bold" }}
              >
                {card.value}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default ItemStatusStatisticsCards;
